import { ErrorHandler, Injectable, Injector } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { ErrorService } from './error.service';
import { ErrorLoggingService } from './error-logging.service';
@Injectable({
    providedIn: 'root'
})
export class GlobalErrorHandler implements ErrorHandler
{
    constructor(private injector: Injector) { }

    handleError(error: Error | HttpErrorResponse)
    {   
        console.error(error);
        const chunkFailedMessage = /Loading chunk [\d]+ failed/;

        if (chunkFailedMessage.test(error.message)) {
          window.location.reload();
        }
        
        // const errorService = this.injector.get(ErrorService);
        // const errorLogService = this.injector.get(ErrorLoggingService);
        // let message;
        // let stackTrace;

        // if (error instanceof HttpErrorResponse){ // Server Error
        //     message = errorService.getServerMessage(error);
        //     stackTrace = errorService.getServerStack(error);
        //     errorLogService.logErrors(error,"back-end",stackTrace);
        // }
        // else{
        //     stackTrace = errorService.getClientStack(error);
        //     message = errorService.getClientMessage(error);
        //     errorLogService.logErrors(error,"front-end",stackTrace);
        // }
            

        // console.log("**************************");
        // console.log(message);
        // console.error(stackTrace);
        // console.log("**************************");
    }
}